import MetadataService from '@/services/MetadataService'
import CategoryService from '@/services/CategoryService'

const createMetadataModule = () => ({
  namespaced: true,
  state: {
    companies: [],
    domains: [],
    categories: [],
    skillLevels: [],
    skills: []
  },
  actions: {
    getMetadata: async ({ commit }) => {
      try {
        const { domains, skillLevels, skills } = await MetadataService.getAll()
        commit('SET_DOMAINS', { domains })
        commit('SET_SKILL_LEVELS', { skillLevels })
        commit('SET_SKILLS', { skills })
      } catch (ex) {
        console.error(`Failed to get metadata: ${ex.message || ex}`)
      }
    },

    getCompany: async ({ commit }, companySlug) => {
      try {
        const { companies } = await MetadataService.getCompany(companySlug)
        commit('SET_COMPANIES', { companies })
      } catch (ex) {
        console.error(`Failed to get company: ${ex.message || ex}`)
      }
    },

    getCategories: async ({ commit }) => {
      try {
        const { categories } = await CategoryService.getCategories()
        commit('SET_CATEGORIES', { categories })
      } catch (ex) {
        console.error(`Failed to get categories: ${ex.message || ex}`)
      }
    }
  },
  getters: {
    domains: (state) => state.domains,
    skillLevels: (state) => state.skillLevels,
    skills: (state) => state.skills,
    companies: (state) => state.companies,
    categories: (state) => state.categories
  },
  mutations: {
    SET_COMPANIES: (state, { companies }) => {
      state.companies = companies
    },
    SET_DOMAINS: (state, { domains }) => {
      state.domains = domains
    },
    SET_SKILL_LEVELS: (state, { skillLevels }) => {
      state.skillLevels = skillLevels
    },
    SET_SKILLS: (state, { skills }) => {
      state.skills = skills
    },
    SET_CATEGORIES: (state, { categories }) => {
      state.categories = categories
    }
  }
})

export default createMetadataModule
